import { Attachment } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { useTrackingModalStore } from 'modules/orders/components/Tracking/trackingModalStore'
import { ActionsItemProps } from './actions'

export const Accompaniments = ({ order, disabled }: ActionsItemProps) => {
  const setModalOpen = useTrackingModalStore.useSetModalOpen()
  const setData = useTrackingModalStore.useSetData()

  return (
    <MenuItem
      onClick={() => {
        setData({
          orderId: order.orderId,
          customerId: order.customer.id
        })
        setModalOpen(true)
      }}
      sx={{
        fontSize: 16
      }}
      disabled={disabled}
    >
      <Attachment sx={{ margin: '8px 15px 0 0' }} />
      <span style={{ margin: '8px 15px 0 0' }}>Acompanhamento</span>
    </MenuItem>
  )
}
